<div class="checkout-metrics-container">
  <div class="date-picker">
    <pdq-date-range-picker
      #datePicker
      class="date-picker"
      (onApply)="loadMetrics($event)"
      petitionType="range"
      [createdAt]="loadedExtension?.createdAt ?? shopCreated()"
      positionRight="true"
      background="light"></pdq-date-range-picker>
  </div>
  <div class="metrics-container">
    @for (metric of metrics; track metric) {
      <metric
        class="metric"
        [suffix]="metric.suffix"
        [prefix]="metric.prefix"
        [value]="metric.value"
        [loading]="loadingMetrics"
        [title]="metric.title"
        [tooltip]="metric.tooltip"></metric>
    }
  </div>
</div>
